import { Link } from "react-router-dom";
import { useSeo } from "@/hooks/useSeo";

export default function NotFound() {
  useSeo({
    title: "页面不存在 - 佐佐木明希官网",
    description: "你访问的页面不存在或已被移除，请返回首页继续浏览佐佐木明希的明星资讯与影视作品。",
    keywords: "佐佐木明希,页面不存在,404",
  });

  return (
    <section className="flex min-h-screen items-center justify-center bg-background-50 px-4 py-24">
      <div className="w-full max-w-lg rounded-lg border border-background-200 bg-background-100 p-10 text-center">
        <p className="font-heading text-6xl font-bold text-primary-500">404</p>
        <h1 className="mt-4 font-heading text-2xl font-bold text-foreground-950">页面走丢了</h1>
        <p className="mt-3 text-sm leading-relaxed text-foreground-600">
          你访问的页面不存在或已被移除。不如回到首页，继续浏览佐佐木明希的最新资讯与影视作品。
        </p>
        <div className="mt-8 flex flex-wrap justify-center gap-3">
          <Link
            to="/"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-6 py-3 text-sm font-label font-medium text-background-50 transition-colors hover:bg-primary-600"
          >
            <i className="ri-home-4-line" aria-hidden="true" />
            返回首页
          </Link>
          <Link
            to="/works"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-6 py-3 text-sm font-label font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            <i className="ri-film-line" aria-hidden="true" />
            浏览影视作品
          </Link>
        </div>
      </div>
    </section>
  );
}